import React from 'react'
import { H4 } from '../../../../../../../AbstractElements';
import { BrandText, CategoryText, ColorsText, NewProducts, Price } from '../../../../../../../Utils/Constants';
import BrandFilter from './BrandFilter';
import ColorsFilter from './ColorsFilter';
import PriceRange from './PriceRange';
import CategoryFilter from './CategoryFilter';

export default function ProductCategory() {

    return (
        <>
            <div className="product-filter">
                <H4 className="f-w-600">{CategoryText}</H4>
                <CategoryFilter />
            </div>
            <div className="product-filter">
                <H4 className="f-w-600">{BrandText}</H4>
                <BrandFilter />
            </div>
            <div className="product-filter slider-product">
                <H4 className="f-w-600">{ColorsText}</H4>
                <ColorsFilter />
            </div>
            <div className="product-filter pb-0">
                <H4 className="f-w-600">{Price}</H4>
                <PriceRange />
                <H4 className="f-w-600 pt-3">{NewProducts}</H4>
            </div>
        </>
    );
};
